import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { api } from "../api/client"
import { useApp } from "../state/AppState"
import { ACCENT_KEYS } from "../design/palette"
import { Button, ColourPicker, Field, Input, Modal, Textarea } from "../components/ui"

export function NewProjectDialog({ open, onClose }) {
	const { refreshProjects, toast } = useApp()
	const navigate = useNavigate()
	const [name, setName] = useState("")
	const [description, setDescription] = useState("")
	const [colour, setColour] = useState("teal")
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState(null)

	useEffect(() => {
		if (open) {
			setName("")
			setDescription("")
			setColour("teal")
			setError(null)
		}
	}, [open])

	async function submit(event) {
		event.preventDefault()
		if (!name.trim()) {
			setError("Give the project a name.")
			return
		}
		setSaving(true)
		try {
			const project = await api.createProject({
				name: name.trim(),
				description: description.trim(),
				colour
			})
			await refreshProjects()
			toast(`Created "${project.name}"`, "success")
			onClose()
			navigate(`/projects/${project.project_id}`)
		} catch (cause) {
			setError(cause.message)
		} finally {
			setSaving(false)
		}
	}

	return (
		<Modal
			open={open}
			onClose={onClose}
			title="New project"
			description="One project per conversation - usually one job, one client, one email chain."
			size="sm"
			footer={
				<>
					<Button onClick={onClose}>Cancel</Button>
					<Button variant="primary" onClick={submit} busy={saving} disabled={saving}>
						Create project
					</Button>
				</>
			}
		>
			<form onSubmit={submit} className="space-y-4">
				<Field label="Project name" error={error}>
					<Input
						value={name}
						onChange={(event) => setName(event.target.value)}
						placeholder="Riverside Court - Phase 2"
						autoFocus
						maxLength={120}
					/>
				</Field>
				<Field
					label="Description"
					hint="Optional. What is being clarified, and between whom."
				>
					<Textarea
						rows={3}
						value={description}
						onChange={(event) => setDescription(event.target.value)}
						placeholder="What this project covers, and who is involved."
						maxLength={600}
					/>
				</Field>
				<Field label="Colour">
					<ColourPicker value={colour} onChange={setColour} options={ACCENT_KEYS} />
				</Field>
			</form>
		</Modal>
	)
}
